"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modelState = exports.undoItems = exports.redoItems = void 0;
exports.redoItems = [
    {
        identifier: 0,
        isRestorable: 0,
        title: 'Redo Item 1',
    },
    {
        identifier: 1,
        isRestorable: 1,
        title: 'Redo Item 2',
    },
];
exports.undoItems = [
    {
        identifier: 0,
        isRestorable: 0,
        title: 'Undo Item 1',
    },
    {
        identifier: 1,
        isRestorable: 1,
        title: 'Undo Item 2',
    },
];
exports.modelState = {
    isDefaultState: false,
    undoRedoState: {
        isClearAllActive: true,
        isRedoActive: true,
        isUndoActive: true,
        isUndoAllActive: true,
        redoItems: exports.redoItems,
        undoItems: exports.undoItems,
    },
};
